if(!customElements.get("inventory-tips")) {
  class InventoryTips extends HTMLElement {
    constructor() {
      super();
    }

    variantIdChangedUnsubscriber = undefined;
    
    connectedCallback() {
      // 元素
      this.elements = {
        productPreOrderTip: $(this.querySelector('.preorder-tip')),
        productInventoryTip: $(this.querySelector('.inventory-start'))
      };

      // 订阅事件：变体切换
      this.variantIdChangedUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        let variant = event.data.variant;
        // 根据当前选中的产品变体库存状态，更新tips
        if (variant.available) {
          let variantInventoryQuantity = window.inventory_quantity[variant.id];
          let variantInventoryPolicy = window.inventory_policy[variant.id];
          // pre order tip
          if(this.elements.productPreOrderTip.length > 0) {
            if(variantInventoryQuantity <= 0){
              this.elements.productPreOrderTip.html(window.inventories[variant.id]);
              this.elements.productPreOrderTip.removeClass('hide');
            }
            else{
              this.elements.productPreOrderTip.text("");
              this.elements.productPreOrderTip.addClass('hide');
            }
          }
          // inventory tip
          if (this.elements.productInventoryTip.length > 0) {
            if(variantInventoryPolicy != 'deny'){
              this.elements.productInventoryTip.addClass("hide");
              this.elements.productInventoryTip.html("");
            }
            else{
              if(variantInventoryQuantity > 20){        
                this.elements.productInventoryTip.addClass("hide");
                this.elements.productInventoryTip.html("");
              }
              else if(variantInventoryQuantity <= 0) {
                this.elements.productInventoryTip.removeClass("hide");
                this.elements.productInventoryTip.html('Oops, ' + variantInventoryQuantity + ' Left!');
              }
              else if (variantInventoryQuantity > 0) {
                this.elements.productInventoryTip.removeClass("hide");
                // this.elements.productInventoryTip.html('Order Now - Only '+ variantInventoryQuantity + ' Left!');
                this.elements.productInventoryTip.html('Only a few left!');
              }
            }
          }
        } else {
          this.elements.productPreOrderTip?.text("");
          this.elements.productPreOrderTip?.addClass('hide');
          this.elements.productInventoryTip?.html("");
          this.elements.productInventoryTip?.addClass("hide");
        }
      });
    }

    disconnectedCallback() {
      if (this.variantIdChangedUnsubscriber) {
        this.variantIdChangedUnsubscriber();
      }
    }
  }

  customElements.define("inventory-tips", InventoryTips);
}
